import { FinancialConnectionRefreshRequestStatus } from '@40seas/entities/financial-connection-refresh-requests';
import { EnumColor } from '@40seas/frontend/common/providers';

export const financialConnectionRefreshRequestStatusMapping = {
    [FinancialConnectionRefreshRequestStatus.Pending]: 'default',
    [FinancialConnectionRefreshRequestStatus.Succeeded]: 'success',
    [FinancialConnectionRefreshRequestStatus.Failed]: 'error',
} as { [key in FinancialConnectionRefreshRequestStatus]: EnumColor };
